// @ts-nocheck
import React from 'react';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  // primary Button
  primaryButton: {
    color: '#233759 !important',
    padding: '10px 16px',
    fontWeight: '600',
    fontFamily: 'Barlow Semi Condensed',
    textTransform: 'uppercase',
    lineHeight: '1',
    fontSize: '0.875rem',

    backgroundColor: '#FBAD33',
    '&:hover': {
      backgroundColor: '#E5A137',
    },
  },
  primaryButtonDisabled: {
    backgroundColor: '#F0840F4D !important',
    color: '#5F6D83 !important',
  },

  primaryButtonSmallSize: {
    padding: '8px 16px',
    fontSize: '0.875rem',
  },
  primaryButtonLargeSize: {
    padding: '13px 16px',
    fontSize: '0.875rem',
  },
  primaryButtonIcon: {
    marginBottom: '1px',
  },

  // primary outlined buttons

  primaryOutlinedButton: {
    color: '#E5A137',
    padding: '10px 16px',
    fontWeight: '600',
    fontFamily: 'Barlow Semi Condensed',
    textTransform: 'capitalize',
    borderColor: '#E5A137',
    lineHeight: '1',
    '&:hover': {
      backgroundColor: '#FEEFD6',
    },
  },

  primaryOutlinedButtonSmallSize: {
    padding: '7px',
  },
  primaryOutlinedButtonLargeSize: {
    padding: '10px 16px',
  },
  primaryOutlinedButtonIcon: {
    marginBottom: '1px',
  },

  //   secondary Button

  secondaryButton: {
    color: '#233759 !important',
    padding: '8px 16px',
    fontWeight: '600',
    textTransform: 'uppercase',
    fontFamily: 'Barlow Semi Condensed',
    fontSize: '0.875rem',

    '&:hover': {
      backgroundColor: '#EAEDF1',
      border: '1px solid #5F6D83',
      padding: '8px 16px',
    },
  },
  // secondaryButtonLabel: {
  //   color: '#233759',
  // },

  secondaryButtonSmallSize: {
    padding: '8px 16px !important',
    lineHeight: '1',
  },
  secondaryButtonLargeSize: {
    padding: '10px 16px',
  },

  secondaryButtonText: {
    border: 'none',
    color: '#233759 !important',

    '&:hover': {
      backgroundColor: 'transparent',
      border: 'none',
    },
  },
  // secondaryButtonDisabled: {
  //   color: '#9E9E9E !important',
  // },

  // delete button

  deleteButton: {
    fontWeight: '500',
    color: '#fff',
    lineHeight: '1.5',
    textTransform: 'uppercase',
    padding: '6px 16px',
    backgroundColor: '#e13939',
    border: 'solid 1px #e13939',
    fontFamily: 'Barlow Semi Condensed',
    '&:hover': {
      backgroundColor: '#d41c1c',
    },
  },

  // delete text button

  deleteTextButton: {
    fontWeight: '500',
    color: '#e13939',
    lineHeight: '1.5',
    textTransform: 'capitalize',
    padding: '6px 16px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  // success button
  successButton: {
    fontWeight: '500',
    color: 'white',
    lineHeight: '1.5',
    textTransform: 'uppercase',
    padding: '6px 16px',
    backgroundColor: '#4CAF50',
    '&:hover': {
      backgroundColor: '#4CAF50',
    },
  },

  //  success outlined button
  successOutlinedButton: {
    fontWeight: '500',
    color: '#4CAF50',
    lineHeight: '1.5',
    textTransform: 'uppercase',
    padding: '6px 10px',
    '&:hover': {
      backgroundColor: '#4CAF50',
      color: 'white',
    },
  },

  // secondary text button

  secondaryTextButton: {
    color: '#233759 !important',
    padding: '8px 16px',
    fontWeight: '600',
    textTransform: 'capitalize',
    fontFamily: 'Barlow Semi Condensed',
    '&:hover': {
      backgroundColor: 'transparent',
      padding: '8px 16px',
    },
  },
}));

interface ButtonProps {
  label: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  children?: React.ReactNode;
  [key: string]: unknown; // For any additional props
}

interface SecondaryButtonProps extends ButtonProps {
  variant?: 'text' | 'outlined' | 'contained';
  isLoading?: boolean;
}

interface PrimaryButtonProps extends SecondaryButtonProps {
  disabled?: boolean;
}

interface DeleteButtonProps extends ButtonProps {
  loading?: boolean;
  disabled?: boolean;
}

/**
 * @deprecated This button is deprecated. Please use the button from atoms
 * */
export function PrimaryButton({
  label,
  startIcon,
  endIcon,
  isLoading,
  children,
  disabled,
  ...rest
}: PrimaryButtonProps) {
  const classes = useStyles();

  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={isLoading ? <CircularProgress size={15} /> : endIcon}
      disabled={disabled || isLoading}
      classes={{
        root: classes.primaryButton,
        disabled: classes.primaryButtonDisabled,
        sizeSmall: classes.primaryButtonSmallSize,
        sizeLarge: classes.primaryButtonLargeSize,
        startIcon: classes.primaryButtonIcon,
        endIcon: classes.primaryButtonIcon,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function PrimaryOutlinedButton({
  label,
  startIcon,
  endIcon,
  children,
  ...rest
}) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      classes={{
        root: classes.primaryOutlinedButton,
        sizeSmall: classes.primaryOutlinedButtonSmallSize,
        sizeLarge: classes.primaryOutlinedButtonLargeSize,
        startIcon: classes.primaryOutlinedButtonIcon,
        endIcon: classes.primaryOutlinedButtonIcon,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      variant="outlined"
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function SecondaryButton({
  label,
  startIcon,
  endIcon,
  variant,
  isLoading,
  children,
  ...rest
}: SecondaryButtonProps) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={isLoading ? <CircularProgress size={20} /> : startIcon}
      disabled={isLoading}
      endIcon={endIcon}
      classes={{
        root: classes.secondaryButton,
        disabled: classes.secondaryButtonDisabled,
        label: classes.secondaryButtonLabel,
        sizeSmall: classes.secondaryButtonSmallSize,
        sizeLarge: classes.secondaryButtonLargeSize,
        textSizeSmall: classes.secondaryButtonText,
      }}
      variant={variant}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function DeleteButton({
  label,
  startIcon,
  loading,
  endIcon,
  disabled,
  children,
  ...rest
}: DeleteButtonProps) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={loading ? <CircularProgress size={20} /> : startIcon}
      disabled={loading || disabled}
      endIcon={endIcon}
      classes={{
        root: classes.deleteButton,
        sizeSmall: classes.deleteButtonSmallSize,
        sizeLarge: classes.deleteButtonLargeSize,
        startIcon: classes.deleteButtonIcon,
        endIcon: classes.deleteButtonIcon,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

export function DeleteTextButton({
  label,
  startIcon,
  endIcon,
  children,
  ...rest
}) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      classes={{
        root: classes.deleteTextButton,
        sizeSmall: classes.deleteButtonSmallSize,
        sizeLarge: classes.deleteButtonLargeSize,
        startIcon: classes.deleteButtonIcon,
        endIcon: classes.deleteButtonIcon,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function SuccessButton({
  label,
  startIcon,
  endIcon,
  children,
  ...rest
}) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      classes={{
        root: classes.successButton,
        sizeSmall: classes.successButtonSmallSize,
        sizeLarge: classes.successButtonLargeSize,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function SuccessOutlinedButton({ label, startIcon, endIcon, ...rest }) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      classes={{
        root: classes.successOutlinedButton,
        sizeSmall: classes.successOutlinedButtonSmallSize,
        sizeLarge: classes.successOutlinedButtonLargeSize,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label}
    </Button>
    // </ThemeProvider>
  );
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export function SecondaryTextButton({
  label,
  startIcon,
  endIcon,
  // variant,
  children,
  ...rest
}) {
  const classes = useStyles();
  return (
    // <ThemeProvider theme={theme}>
    <Button
      startIcon={startIcon}
      endIcon={endIcon}
      classes={{
        root: classes.secondaryTextButton,
        disabled: classes.secondaryButtonDisabled,
        label: classes.secondaryButtonLabel,
        sizeSmall: classes.secondaryButtonSmallSize,
        sizeLarge: classes.secondaryButtonLargeSize,
      }}
      disableElevation
      disableFocusRipple
      disableRipple
      {...rest}
    >
      {label || children}
    </Button>
    // </ThemeProvider>
  );
}
